import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Opens the tab named in the URL (e.g. `?tab=archived`), so links such as the global
// search results can open a page on a specific tab. It runs on every navigation
// (location.key), so it also switches tabs when the page is already open, even when
// the same link is opened twice.
//
// `values` are the page's tab values; the URL value is matched case-insensitively and
// `onTab` gets the page's own spelling. Unknown values are ignored.
export const useUrlTab = (onTab, values, param = "tab") => {
  const { search, key } = useLocation();
  useEffect(() => {
    const requested = new URLSearchParams(search).get(param);
    if (!requested) return;
    const match = values.find((value) => String(value).toLowerCase() === requested.toLowerCase());
    if (match !== undefined) onTab(match);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search, key]);
};

// The page's own spelling of a tab value from the URL, or undefined
export const getUrlTab = (search, values, param = "tab") => {
  const requested = new URLSearchParams(search).get(param);
  return requested ? values.find((value) => String(value).toLowerCase() === requested.toLowerCase()) : undefined;
};
